import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useCurrentUserProfile } from '../../contexts/CurrentUserProfileContext';
import { clearAllQueryCache, removeLegacyPersistedQueryCaches } from './clearQueryCache';
import { activeUserIdRef } from './activeUserIdRef';

/** Clears React Query cache when the signed-in user changes or signs out. */
export default function AuthQueryCacheSync() {
  const queryClient = useQueryClient();
  const { session, authReady } = useCurrentUserProfile();
  const prevUserIdRef = useRef(undefined);

  useEffect(() => {
    removeLegacyPersistedQueryCaches();
  }, []);

  useEffect(() => {
    // Before auth has booted, session is just the initial null - not a sign-out. Treating it as one wiped the
    // in-memory cache (queryClient.clear) on every cold start as soon as the real user arrived.
    if (!authReady) return;
    const userId = session?.user?.id ?? null;
    activeUserIdRef.current = userId;

    if (prevUserIdRef.current !== undefined && prevUserIdRef.current !== userId) {
      clearAllQueryCache(queryClient, prevUserIdRef.current);
    }
    prevUserIdRef.current = userId;
  }, [session?.user?.id, authReady, queryClient]);

  return null;
}
